/* eslint @typescript-eslint/consistent-type-assertions: 0 */

import { PermissionsPermissionType as Data } from '@/typings/api/PermissionsPermissionType'
import { Model, createMessages } from '@/helpers/Model'


export class PermissionsModel extends Model<Data> {
  public static readonly page_title = createMessages({
    create: 'Добавить право',
    edit: 'Редактировать право',
    view: (data: PermissionsModel) => 'Право «{name}»'
      .replace('{name}', data.name || '...'),
    list: 'Права',
  });

  public static readonly modal_delete = createMessages({
    delete: (data: PermissionsModel) => 'Удаление права «{name}»'
      .replace('{name}', data.name || '...'),
    delete_all: 'Удаление выбранных прав',
    delete_all_partly: 'Удаление части выбранных прав',
  });

  public static readonly response_error = createMessages({
    ...Model.response_error,
    read_all: 'Ошибка загрузки данных разрешений',
  }) as typeof Model.response_error;
}
